<template>
  <div v-if="client" class="section-details">
    <div class="entete border-entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3"  v-if="isNewClient">
                  {{ $t('editionClient.titleCreation')}}</h1>
                <h1 class="title is-size-3"  v-else>
                  {{ $t('editionClient.titleChange', { nomCommercial: libelle })}}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <a @click="$router.go(-1)"
                 class="button is-cancel btn-modal-annuler ">
                {{ $t('editionClient.actions.revert')}}
              </a>
              <dropdownButton
                type="is-addOrEdit"
                class="mgr-2"
                :actions="actionSecondary"
                @click="ouverturePopUp">
                  {{ $t('general.button.sauvegarder') }}
              </dropdownButton>
              <piece-jointe-button
                class="mgr-2"
                :perm="permTiers.maj">
              </piece-jointe-button>
            </div>
          </div>
        </div>
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
    </div>
    <div class="pdt-20px">
      <app-edition-client
        :client="client" :error="error"/>
    </div>
    <b-modal v-model="popUpChangementDevisCommandeFacture" has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="$t('editionClient.popUpChangementInDCF.title')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @no="sauvegarderClient(false)"
                         @yes="sauvegarderClient(true)">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import dropdownButton from '@/components/general/button/dropdownButton';
import { get } from '@/api/tiers/index';
import { getAllByTiers } from '@/api/contacts/index';
import clientGenerer from '@/services/tiers/genererTiers';
import { insertTiers, updateTiers } from '@/services/tiers/saveTiers';
import validation from '@/services/tiers/validationTiers';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import EditionClient from '@/components/clients/clients/editionClient/index';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { REMOVE_COMMANDE } from '@/store/modules/commande-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import validationGeneral from '@/services/validation/validation';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';
import popUpPrevention from '@/components/general/popUpPrevention';
import adressFullClient from '@/services/general/adresseFullClient';
import initialize from '@/services/tiers/initializeTiers';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { TIERS } from '@/configuration/permissionsBodacConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Clients = createNamespacedHelpers('clients');
const Attachments = createNamespacedHelpers('attachments');
const societe = createNamespacedHelpers('societe');
const Commandes = createNamespacedHelpers('commande');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    appEditionClient: EditionClient,
    AppBreadcrumb,
    dropdownButton,
    errorMsgComponent,
    popUpPrevention,
    pieceJointeButton,
  },
  data() {
    return {
      messages: [],
      id: '',
      error: false,
      champsVide: [],
      messagesChampsVide: [],
      isNewClient: true,
      client: null,
      popUpChangementDevisCommandeFacture: false,
      libelle: '',
      tiersBase: null,
      permTiers: TIERS,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!['m.bodac.devis-creation', 'm.bodac.devis', 'm.bodac.devis-client', 'm.bodac.factures-client', 'm.bodac.commandes-ajout', 'm.bodac.commandes', 'm.bodac.commandes-client'].includes(to.name)) {
      this.removeCommande();
    }
    next();
  },
  computed: {
    ...Clients.mapGetters({
      clientCourant: 'clientCourant',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeClients.title'), route: { name: 'l.bodac.clients/contacts-clients' }, isActive: false },
        { title: this.$i18n.t('editionClient.titleChange', { nomCommercial: this.libelle }), route: { name: 'm.bodac.clients/contacts-editClient' }, isActive: true },
      ];
      if (this.isNewClient) {
        output[2].title = this.$i18n.t('editionClient.titleCreation');
        output[2].route = { name: 'm.bodac.clients/contacts-addClient' };
      }
      return output;
    },
    actionSecondary() {
      const actions = [
      ];

      if (!this.isNewClient) {
        actions.push(
          {
            label: this.$t('editionClient.actions.saveWithoutUpdateDCF'),
            action: () => { this.sauvegarderClient(false); },
          },
        );
      }

      return actions;
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Clients.mapActions({
      setClientCourant: 'setClientCourant',
    }),
    ...Commandes.mapMutations({
      removeCommande: REMOVE_COMMANDE,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async sauvegarderClient(updateDCF) {
      const loadingComponent = this.$buefy.loading.open();
      this.popUpChangementDevisCommandeFacture = false;
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        let client = {};
        if (this.isNewClient) {
          this.client.contacts.forEach((el) => {
            delete el.guid;
          });
          this.client.societeId = this.societeActiveId;
          client = await insertTiers(this.client);
          await this.insertAttachments(client.id);
          messageSucces(this.$i18n.t('editionClient.messages.successCreation'));
        } else {
          this.client.updateDCF = updateDCF;
          client = await updateTiers(this.client);
          await this.updateAttachments(client.id);
          messageSucces(this.$i18n.t('editionClient.messages.successChange'));
        }
        loadingComponent.close();
        let routeData = {};
        switch (this.$route.name) {
          case 'm.bodac.clients/contacts-editCommande':
            this.setClientCourant(client);
            await this.$router.push({ name: 'm.bodac.commandes-client' });
            break;
          case 'm.bodac.clients/contacts-editDevis':
            this.setClientCourant(client);
            await this.$router.push({ name: 'm.bodac.devis-client' });
            break;
          case 'm.bodac.clients/contacts-editFacture':
            this.setClientCourant(client);
            await this.$router.push({ name: 'm.bodac.factures-client' });
            break;
          case 'm.bodac.clients/contacts-editPlanMedia':
            this.setClientCourant(client);
            routeData = { name: 'm.presse.plan_media-add' };
            if (this.$route.params.planMediaId) {
              routeData = {
                name: 'm.presse.plan_media-edit',
                params: { id: this.$route.params.planMediaId },
              };
            }
            await this.$router.push(routeData);
            break;
          default:
            await this.$router.push({
              name: 'c.bodac.clients/contacts-client', params: { id: client.id },
            });
            break;
        }
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, champsTiersTranslator);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    ouverturePopUp() {
      if (this.isNewClient) {
        this.sauvegarderClient(false);
        return;
      }
      if (this.tiersBase && (this.client.adresseFacturationDifferente
          && adressFullClient(this.tiersBase.adresseFacturation)
          !== adressFullClient(this.client.adresseFacturation))
        || this.client.nomCommercial !== this.tiersBase.nomCommercial
        || adressFullClient(this.tiersBase.adressePostale)
        !== adressFullClient(this.client.adressePostale)) {
        this.popUpChangementDevisCommandeFacture = true;
      } else this.sauvegarderClient(false);
    },
  },
  async mounted() {
    await this.setAttachmentContext({ module: 'Client' });
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
    if (this.clientCourant) {
      this.client = this.clientCourant;
      this.setClientCourant(null);
      return;
    }

    if (!this.$route.params.id) {
      this.client = clientGenerer();
      this.client.type = TIERS_TYPE_CLIENT;
      this.client.sousTypes = [TIERS_SOUS_TYPE_AUCUN];
      if (this.societeActive.roles.length === 1) {
        this.client.role = this.societeActive.roles[0];
      }
      this.client.modeReglementId = this.societeActive.modeReglementId;
      this.client.delaiReglementId = this.societeActive.delaiReglementId;
      this.client.factureParMail = this.societeActive.factureParMail;
      if (this.moduleStockTiersActive) {
        this.client.lieuStockage = this.societeActive.lieuStockageDefault;
      }
      this.setInformationPage(this.$t('pageGescom.client.creation'));
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    this.isNewClient = false;
    this.id = this.$route.params.id;
    try {
      const clientResponse = await get(this.id);
      await this.setAttachmentElementId({ id: this.id });
      let client = null;
      client = { ...clientResponse.data.result };
      const responseContacts = await getAllByTiers(client.id);
      client.contacts = responseContacts.data.result.items;
      this.setInformationPage(this.$t('pageGeneral.modification', { item: client.nomCommercial }));
      this.libelle = cloneDeep(client.nomCommercial);
      this.tiersBase = cloneDeep(client);
      this.adresse = adressFullClient(cloneDeep(client.adressePostale));
      this.adresseFacturation = adressFullClient(cloneDeep(client.adresseFacturation));
      this.nomCommercial = cloneDeep(this.nomCommercial);
      initialize(client);
      this.client = client;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
